import authTypes from "../types/auth";
import { config } from "../../config";

export const initialState = {
  logindata: "",
  recruiterList: [],
  candidatelist: [],
  addrecruiter: {},
  editrecruiter: {},
  addcandidate: {},
  editcandidate: {},

  apiError: "",
  isauthLoading: false,
  token: "",
  codingTheme: {
    theme: "vs-dark",
    themeId: 1,
  },
  codingLang: {
    cid: 10,
    lang: "java",
    langId: 10,
  },
  resumeUrl: "",
  resumeName: "",
  resumeSize: 0,
  resumeScore: 0,
  resumeUrlError: {},
  leve: null,
  candidatedetails: {},
  recruiterdetails: {},
  userExists: false,
  candidateDeactive: null,
  candidateActive: null,
  recruiterDeactive: null,
  recruiteractive: null,
  recruiterfilter: {
    addedBy: [],
    status: ["active", "inactive"],
    recruiterType: ["Contributor", "Lead"],
  },
  recruiterlistTotal: 0,
  candidateListTotal: [],
  candidateListMyTotal: 0,
  candidateListAllTotal: 0,
  recruiterdashboard: [],
  candidatefilter: {
    createdBy: [],
    degree: ["Bachelors", "Masters", "PhD", "Other"],
    skills: [],
    status: ["active", "inactive"],
    yoe: ["0-3 Years", "4-6 Years", "7 Years & Above", "Unknown"],
  },
  uploadresume: [],
  searchByEmail: [],
  resumeremove: [],
  downloadresume: [],
  areaOfStrengthsAndImprovements: {},
  candidateDPUrl: null,
  fetchedResumeDetails: null,
  uploadprofile: [],
};

function auth(state = initialState, action) {
  switch (action.type) {
    case authTypes.GET_AOSI_SUCCESS:
      return {
        ...state,
        isauthLoading: false,
        areaOfStrengthsAndImprovements: action?.payload,
      };
    default:
      return { ...state };
  }
}

export default auth;
